export const Agenda = [
  {
    path: '/agenda/:app_module_id',
    name: 'agenda.index',
    component: () => import('@/pages/Agenda/AgendaModule')
  },
  {
    path: '/agenda/:app_module_id/:item_id',
    name: 'agenda.details',
    component: () => import('@/pages/Agenda/AgendaDetails')
  },
  {
    path: '/agenda/:app_module_id/:item_id/:profile_id',
    name: 'agenda.profile',
    component: () => import('@/pages/Agenda/AgendaProfile')
  }
]
